/* Native dialog provides focus trapping, Escape and focus restoration. */
(function () {
  'use strict';
  function init() {
    var button = document.querySelector('[data-ama-natures-open]');
    var dialog = document.getElementById('ama-natures-gift');
    if (!button || !dialog || typeof dialog.showModal !== 'function') return;
    var previousOverflow = '';
    function syncButton() {
      var consent = document.querySelector('.ama-consent');
      button.hidden = dialog.open || !!(consent && !consent.hidden) ||
        !!document.querySelector('.ama-gift.is-open') || document.body.classList.contains('page-overlay-cart-on');
    }
    button.addEventListener('click', function () {
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      button.setAttribute('aria-expanded', 'true');
      syncButton();
    });
    dialog.querySelector('[data-ama-natures-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', function () {
      document.body.style.overflow = previousOverflow;
      button.setAttribute('aria-expanded', 'false');
      syncButton();
      if (!button.hidden) button.focus({ preventScroll: true });
    });
    var observer = new MutationObserver(syncButton);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    ['.ama-consent', '.ama-gift'].forEach(function (selector) {
      var element = document.querySelector(selector);
      if (element) observer.observe(element, { attributes: true, attributeFilter: ['hidden', 'class'] });
    });
    syncButton();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
